import { DestroyRef, Injectable, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { I18nService } from "@app/core/services/i18n.service";
import { DecimalPipe } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root"
})
export class I18nPaginatorService extends MatPaginatorIntl {
  private i18nService = inject(I18nService);
  private decimalPipe = inject(DecimalPipe);
  private _destroyRef = inject(DestroyRef);
  public ofLabel = "of";

  constructor() {
    super();

    this._getAndInitTranslations();
  }

  /**
   * Initialize pager translations
   */
  private _getAndInitTranslations(): void {
    this.i18nService.translateService
      .selectTranslate([
        "TABLE.PAGINATOR.LBL_ITEMS_PER_PAGE",
        "TABLE.PAGINATOR.LBL_FIRST_PAGE",
        "TABLE.PAGINATOR.LBL_NEXT_PAGE",
        "TABLE.PAGINATOR.LBL_PREVIOUS_PAGE",
        "TABLE.PAGINATOR.LBL_LAST_PAGE",
        "TABLE.PAGINATOR.LBL_OF"
      ])
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((translation) => {
        [
          this.itemsPerPageLabel,
          this.firstPageLabel,
          this.nextPageLabel,
          this.previousPageLabel,
          this.lastPageLabel,
          this.ofLabel
        ] = translation;

        this.changes.next();
      });
  }

  /**
   * @returns A label for the range of items within the current page and the length of the whole list
   */
  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofLabel} ${this.decimalPipe.transform(length)}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${this.decimalPipe.transform(startIndex + 1)} - ${this.decimalPipe.transform(endIndex)} ${
      this.ofLabel
    } ${this.decimalPipe.transform(length)}`;
  };
}
